import Feedbacks from './feedbacks'

export default [
  {
    path: '/null',
    component: () => import('@/components'),
    children: [
      ...Feedbacks
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/feedback/index.js